import { CategoryNaturalKey } from './models/category';
import {
    CommunicationReport, GeneralReport, LabManualsReport, LabReport,
    Report, SiteActionsReport, SynopsisReport, TrainingMaterialsReport
} from './models/report';

export function getReportType(categoryId: CategoryNaturalKey) {
    switch (categoryId) {
        case 'general-training-materials':
        case 'general-manuals':
        case 'regulatory-documents':
        case 'general-information':
        case 'quick-reference-guide':
        case 'general-communications':
        case 'specimen-collection':
        case 'packaging-and-shipping':
        case 'application-training':
            return GeneralReport;

        case 'lab-manuals':
        case 'study-manuals':
        case 'lab-manuals-others':
            return LabManualsReport;

        case 'synopsis':
            return SynopsisReport;

        case 'training-materials':
        case 'training-materials-e-learning':
        case 'training-materials-others':
            return TrainingMaterialsReport;

        case 'site-communications':
        case 'sponsor-communications':
        case 'sponsor-communications-e-learning':
        case 'sponsor-communications-main':
            return CommunicationReport;

        case 'site-actions':
            return SiteActionsReport;

        case 'lab-reports':
            return LabReport;
        
        case 'result-alerts':
            return LabReport;

        default:
            return Report;
    }
}